'use client';

import React from 'react';
import { Box, Button, Text } from '@chakra-ui/react';
import { SubmitApplicationForm } from '../forms';
import { CanLogoIcon } from '@/../public/assets/icons';
import { getPendingApplication } from '@/services/application/application.service';
import { Application } from '@/core/models/application';
import BarLoader from '@/components/ui/loaders/BarLoader';
import Link from 'next/link';
import useAuthFunc from '@/hooks/auth/useAuthFunc';

const ApplicationVerification = () => {
   const { handleLogout } = useAuthFunc();
   const [isLoading, setIsLoading] = React.useState(true);
   const [application, setApplication] = React.useState<Application | null>(null);
   const fetchPendingApplication = React.useCallback(async () => {
      const [error, data] = await getPendingApplication();

      if (error) {
         console.log(error);
         setApplication(null);
         setIsLoading(false);
         return;
      }

      setApplication(data.response);
      setIsLoading(false);
   }, []);

   React.useEffect(() => {
      fetchPendingApplication();
   }, [fetchPendingApplication]);

   if (isLoading) {
      return <BarLoader />;
   }

   if (application && application?.status !== 'rejected') {
      return (
         <Box display="flex" flexDirection="column" alignItems="center" gap="10px" h="100%" justifyContent="center">
            <Box
               style={{
                  height: '80px',
                  width: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#F5E876',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
               }}
            >
               <img src="/assets/images/tick.png" alt="check image" />
            </Box>
            <Text fontWeight="bold" fontSize="6xl" textAlign="center">
               APPLICATION SUCCESSFULLY SUBMITTED
            </Text>
            <Box textAlign="center">
               <Text as="p">You have successfully applied for your Cancard.</Text>
               <Text as="p">We will notify you whenever it’s ready.</Text>
            </Box>
            <Link href="/">
               <Button width="150px" mt="10px" height="40px" onClick={handleLogout}>
                  Ok
               </Button>
            </Link>
         </Box>
      );
   }

   return (
      <>
         <Box minH="72px">
            <CanLogoIcon />
         </Box>
         <Text
            as="h2"
            color="white"
            fontSize={{ base: '4xl', sm: '5xl', md: '12xl' }}
            fontWeight="bold"
            textAlign="center"
         >
            VERIFICATION DETAILS
         </Text>
         <Text>
            To complete your Cancard application, please upload a recent photo and either your Summary of Care or proof
            of a qualifying condition from your GP.
         </Text>
         <SubmitApplicationForm setApplication={setApplication} />
      </>
   );
};

export default ApplicationVerification;
